import { Link } from 'react-router-dom';
import { rankingComics } from '@/mocks/comics';

export default function RankingSection() {
  return (
    <section className="py-16 md:py-24 px-6 max-w-screen-xl mx-auto">
      {/* Header */}
      <div className="flex items-end justify-between mb-12">
        <div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-50">
            人气排行
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            最受欢迎的韩漫作品
          </p>
        </div>
        <Link
          to="/category/action"
          className="text-sm text-primary-400 hover:text-primary-300 transition-colors flex items-center gap-1 whitespace-nowrap"
        >
          查看完整榜单
          <i className="ri-arrow-right-line text-sm"></i>
        </Link>
      </div>

      {/* Ranking Cards */}
      <div className="grid grid-cols-5 gap-4 md:gap-6">
        {rankingComics.map((comic) => (
          <Link
            key={comic.rank}
            to={`/comic/${comic.slug}`}
            className="group relative rounded-lg overflow-hidden bg-background-100 cursor-pointer"
          >
            {/* Cover */}
            <div className="relative aspect-[3/4] overflow-hidden">
              <img
                src={comic.coverImage}
                alt={comic.title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              {/* Rank Number */}
              <div className={`absolute top-2 left-2 w-7 h-7 rounded-md flex items-center justify-center text-xs font-black ${
                comic.rank === 1
                  ? 'bg-accent-500 text-background-950'
                  : comic.rank === 2
                  ? 'bg-secondary-400 text-background-950'
                  : comic.rank === 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-800/60 text-foreground-200'
              }`}>
                {comic.rank}
              </div>
              {/* Dark Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent opacity-70" />
            </div>

            {/* Title */}
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <h3 className="text-sm font-bold text-foreground-50 truncate">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-400 mt-0.5">
                {comic.views}次阅读
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}